import { StatsDetailsTabEnum } from '@/features/gateway/types'
import { useCurrentReflection } from '@/hooks'
import { useApiQuery } from '@/utils/use-api-query'
import { $t } from 'packages/locale'
import { FC, useContext } from 'react'

import { IndexBoardCard } from '../components/IndexBoardCard'
import { DataBoardContext } from '../context'
import { useStatsApiQuery } from '../utils/query'

/**
 * 请假卡片
 *
 * @returns 请假卡片
 */
export const AbsenceCard: FC = () => {
  const { semesterInfo, timeRange } = useContext(DataBoardContext)
  const reflection = useCurrentReflection()

  const apiQuery = useStatsApiQuery({
    timeRange,
    semesterInfo,
  })

  const { data: res, loading } = useApiQuery({
    apiName: 'queryAdvisorStudentAbsenceStats',
    params: {
      query: apiQuery,
    },
    options: {
      enabled: !!reflection?.usin,
    },
  })

  const { data: absence } = res || {}

  const attendanceInfo = absence?.[0]

  return (
    <IndexBoardCard
      title={$t('请假统计')}
      count={attendanceInfo?.total_user_count ?? 0}
      items={[
        {
          label: $t('课节数'),
          value: attendanceInfo?.total_lessons_count ?? 0,
          unit: $t('节'),
        },
      ]}
      flex={1}
      type={StatsDetailsTabEnum.StudentAbsence}
      loading={loading}
      itemIconMsg={{
        name: 'Clock',
        color: '#E01BD3',
        backgroundColor: '#FFE8FA',
      }}
    />
  )
}
